export const languageHashValues= {
  "GLOBAL": ".6dd2f822724c59412cae",
  "U4302_TRANSACTIONSDETAIL": ".a0bfad1ce4b09a291a5e",
  "U4400_PAYMENT": ".942a318f8e108db4fa78",
  "U5122_INVOICEMODIFICATIONAPPROVAL": ".33f8c37aa81e448a80db",
  "U2117_PADAGREEMENTINVITATION": ".26091614767dcbd5e5b8",
  "U2000_PAD": ".49632c614a2e4dd56a5c",
  "U4402_INVOICEPORTALPAYMENT": ".eb3b94f4727103ce15c2",
  "U2000_BANKACCOUNTCREATION": ".e760cc3b66c31981739d",
  "U2011_LOGIN": ".7f837d2b0c7337647e9a",
  "U2012_LOGINHELP": ".fa6e696a23274dfb3c8f",
  "U2014_SECURITY": ".bc0acbcc0baa60d442cf",
  "U2086_EFTPENDINGPAYMENTS": ".433c27421e5c7c9e4a57",
  "U2087_EFTPAYMENTSNOTIFICATIONS": ".c316c055829be05bc4ba",
  "U2110_ACCOUNTCREATION": ".1c24feb60f0022884a3c",
  "U2121_INDIVIDUALPROFILE": ".20b66de20d5b299e5fe0",
  "U2131_ORGANIZATIONPROFILE": ".4f19cbb058cce72d13cb",
  "U2112_ERPBINDING": ".c43f29be545281bc7c4f",
  "U2113_SUPPLIERINVITATION": ".463ee9be0cb6e371aa82",
  "U2132_AFFILIATION": ".f7c19e5b368dffcd00fe",
  "U2133_BUSINESSLINKS": ".c5072ea834e78ea14b88",
  "U2181": ".0c5705476c2c6f6a7e99",
  "U2211_SUBSCRIPTIONOFFER": ".8dbc8a17e45568fec756",
  "U2212_SUBSCRIPTIONFILTER": ".cec44fa3f17ea2ec91c6",
  "U2213_SUBSCRIPTION": ".ddd57c9a40dba9e1e0b4",
  "U4111_CREDITCARDADDITION": ".de785a271281ec38750f",
  "U4112_CREDITCARDDETAIL": ".9a85838596f155300fee",
  "U4121_BANKACCOUNTADDITION": ".42c757a4c2fcf0575830",
  "U4122_BANKACCOUNTDETAIL": ".20cc8a576c65602cf682",
  "U4303_ANONYMOUSTRANSACTION": ".b5246c147bb159499354",
  "U4401_PAYMENTGATEWAY": ".d186e270488e48a4c3b3",
  "U4481_PROCESSINVOICEINSTALMENTPAYMENTS": ".b8304ff4cbdfb710fa5b",
  "U5000_RECEIVABLE": ".e1d23c88270d45b738a3",
  "U5101_STATEMENTOFACCOUNT": ".5e10a02efeeaf85377e0",
  "U5102_INVOICE": ".e4ee5a101975d95623ba",
  "U5103_PADAGREEMENT": ".d9a9ce1415a127edcad6",
  "U5121_SENTINVOICE": ".3c016ea13a94bf0d20ec",
  "U5124_PGRECEIVEDPAYMENT": ".2bb1a356f4d44894111e",
  "U5120_INVOICES": ".189432423deaf7d54091",
  "U5123_PADAGREEMENTCONSOLE": ".6d03d5509a90ca07c290",
  "U5132_PAYMENTRECONCILIATION": ".40f33fbf414a087aee7e",
  "U5133_BANKRECONCILIATION": ".b3e6b00bde16c58ac7d5",
  "U6112_BUSINESSLINK": ".9e0968a6a4ec75a46132",
  "U6113_SUPPLIERRECORD": ".a11b57e30f61227e0fdc",
  "U6211_PAYLOT": ".7538ade739fa8ae5f20f",
  "U6311_PURCHASE": ".0f4a68d39a49c98392d5",
  "U2115_AFFILIATIONINVITATION": ".dc6e769718eb18a1551c",
  "U6100_PAYABLE": ".2a8a7efd67172c3c21fe",
  "U6131_SENTPAYMENT": ".6f4ddaa225379be64145",
  "U6191_SENTPAYMENTREPORT": ".56d2cebefe464bb32acb",
  "U6221_SENTPAYMENT": ".e4f6a5d0f55b9629993c",
  "U6422_INTERACSENTPAYMENT": ".21662091c8ab8f0eeab4",
  "U6531_TRANSACTIONPAYMENT": ".2ab52af7bbb861dc898f",
  "U5131_RECEIVEDPAYMENT": ".e5ccc00caa34c3758e1b",
  "U5191_RECEIVEDPAYMENTREPORT": ".737f143f1268ec65dc54",
  "U6141_INVOICEDATA": ".97ef6897a96c4e05a505",
  "U6142_INVOICEDATA": ".b3184e98d393589e01c5",
  "U2001_HOME": ".65bfd2537d09db86c5de",
  "U2024_REPORTLOG": ".ef0dd7e82d8731177c06",
  "U2111_INVOICEPORTALBINDING": ".bc29c522214309dea5c8",
  "U2116_ANONYMOUSSUPPLIERINVITATION": ".968c8253250855252881",
  "U6111_SUPPLIERINVITATIONCONSOLE": ".fb8ac818e8709e7e9b96",
  "U6511_TRANSACTIONPARTY": ".83abee594b5b4a02475e",
  "U6212_PAYROLLPARTY": ".359d219ec20052dacc14",
  "U6121_EFTLOT": ".b5957f10d8cd832061a3",
  "U6412_INTERACFILE": ".ec0b6d3832307fdd5ebd",
  "U6122_EFTAPPROVAL": ".7ae2968276db0c1a380c",
  "U6512_TRANSACTIONLOT": ".7af5cef5cb0fee7d446a",
  "U2027_EFTLOT": ".80cf80281e3e3de05105",
  "U6123_EFTAPPROVAL": ".c51049aa6f97d4c73085",
  "U6123_EFTAPPROVALMOBILE": ".235170235bbc0f45257b",
  "U2012_LOGIN": ".8c3ac70a96f9d5e203b7",
  "U6611_RESELLERCLIENT": ".ef1b08308a6330589735",
  "U2000_PAYMENT": ".21468e2f1b83fbec0365",
  "U4101_CREDITCARDBANKACCOUNTSUMMARY": ".9009dcba1cadf76d5486",
  "U2000_PAYMENTMODEUPDATE": ".68cbca8efb87a06050c4",
  "U6114_TELUSBILLER": ".637d84ec8cf0152feb70",
  "U4403_CREDITCARDTERMINAL": ".a159ee3050bd281f059b",
  "U4404_INTERACTERMINAL": ".9cc84637f49e1034584f",
  "U2000_SAMPLECHEQUESELECTION": ".cf440eee98c77370bc71",
  "U2023_TUTORIALVIDEO": ".5a0e50522e3f4640f8c1",
  "U2134_ORGANIZATIONBILLING": ".970312703a4d486b3c29",
  "U6414_BANKACCOUNTWALLET": ".4fadb4dcab26b0095711",
  "U2022_INSTANTACCOUNTVERIFICATION": ".aff77ec5126f63a3f98c",
  "U6532_PENDINGTRANSACTION": ".9f276c6f7d93dc2559a8",
  "U4301_TRANSACTIONSSUMMARY": ".ae7e00f1d02970e5e00d",
  "U2026_NETPROMOTERSCORE": ".5ff66cdda571dd71d2c6",
  "U2000_ACCOUNTPERSONNALINFORMATIONS": ".f802fdaa3c33163f700b",
  "U2000_INTRO": ".90b9c00b6da8adff54ed",
  "U2000_ATTACHMENTVIEWER": ".8809d3e8064755b12444",
  "U2000_ELECTRONICSIGNATURE": ".596160778c1b261f5959",
  "U2000_VERIFYEMAIL": ".aeb7b6f2a902b2275241",
  "U2200_SUBSCRIPTION": ".c6432fdf83048f7bee99",
  "U2118_RBBINDING": ".33e599bdd48b5e3b188b",
  "U2028_RELEASENOTE": ".08a7ed814cd0c592c3d5",
  "U2000_VERIFYIDENTITY": ".d7758de00d187c64379b",
  "U2212_PLANLIST": ".b02c442269f6dd73c0f0",
  "U3002_TAXBILLSEARCHRESULT": ".b8a758d2b33759cc83fe"
}